import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
import Header from "./Header";
import { convertDBDate } from "./common";
import moment from "moment";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import {
  GetMemberInfo,
  GetMemberActivity,
  GetInvoiceData,
} from "../../components/UserMembershipApplication/Api/services/Webservices";
import Invoice from "../Template/invoice";
import PaymentReceipt from "../Template/payment";
import Footer from "./Footer";
import { encryptSlug, decryptSlug } from "../../util/encryption";
import MembershipCertificate from './certificate/membership-certificate-web';
import axios from "axios";
import { baseUrl } from "../../api/common";
import { convertCertificateDate } from './common';
const UserMemberApplicationTracking = () => {
  
  const { slug } = useParams();
  const decryptedId = decryptSlug(slug);
  const [memberDetails, setMemberDetails] = useState({});
  const [memberActivityData, setMemberActivityData] = useState([]);
  const [memberPaymentActivityData, setMemberPaymentActivityData] = useState([]);
  const [invoiceData, setInvoiceData] = useState(null);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [invoiceError, setInvoiceError] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showPaymentReceipt, setShowPaymentReceipt] = useState(false);

  const handlePaymentReceiptClick = async () => {
    setInvoiceError(null);
    try {
      const formData = new FormData();
      formData.append("id", decryptedId); // Pass the 'slug' here

      const data = await GetInvoiceData(formData);
      setInvoiceData(data);
      setShowPaymentReceipt(true);
    } catch (error) {
      setInvoiceError(error.message || "Error fetching invoice data");
    } 
  };
  
  const handleClosePaymentReceipt = () => {
    setShowPaymentReceipt(false);
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append("id", decryptedId);
    const MemberFormdata = formData;
    GetMemberInfo(MemberFormdata)
      .then((res) => {
        if (res.status === true && res.data && res.data.length > 0) {
          const details = res.data[0];
          setMemberDetails(details);
        }
        if (
          res.status === true &&
          res.payment_status &&
          res.payment_status.length > 0
        ) {
          setMemberPaymentActivityData(res.payment_status);
        }
      })
      .catch((error) => {
        showToast(error.message || "An error occurred", "error");
      });

    const postformData = new FormData();
    postformData.append("member_id", decryptedId);
    const activityFormdata = postformData;

    GetMemberActivity(activityFormdata)
      .then((res) => {
        console.log(res);
        if (res.status === true && res.data && res.data.length > 0) {
          setMemberActivityData(res.data);
        }
      })
      .catch((error) => {
        showToast(error.message || "An error occurred", "error");
      });
  }, []);

  const handleInvoiceClick = async () => {
    setLoadingInvoice(true);
    setInvoiceError(null);

    try {
      const formData = new FormData();
      formData.append("id", decryptedId); // Pass the 'slug' here

      const data = await GetInvoiceData(formData);
      setInvoiceData(data);
      setShowInvoice(true); // Show the invoice when data is fetched
    } catch (error) {
      setInvoiceError(error.message || "Error fetching invoice data");
    } finally {
      setLoadingInvoice(false);
    }
  };

  const handleCloseInvoice = () => {
    setShowInvoice(false);
  };

  const [showMembershipCertificate, setShowMembershipCertificate] = useState(false);
  const [certificateDetails, setCertificateDetails] = useState({});
  const handleMembershipCertificateClick = async (applicationDate) => {
    try {
      const response = await axios.post(`${baseUrl}/api/certificate_data_list`,
        { member_apply_date: applicationDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
      if (response.data.status) {
        setCertificateDetails(response.data.data[0]);
        setShowMembershipCertificate(true);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleCloseMembershipCertificate = () => {
    setShowMembershipCertificate(false);
  };

  return (
    <div className="user_application_div_clr user_tab">
      <ToastMessage />
      <section className="user_div_total">
        <Header />
        {memberDetails && (
          <div className="container pt-50">
            <div className="row">
              <div className="col-md-6">
                <div className="tracking_head">
                  <h2>Tracking Status</h2>
                </div>
              </div>
              <div className="col-md-6 text-end">
              { memberDetails && memberDetails.membership_no ?
                  <button
                    onClick={() => handleMembershipCertificateClick(memberDetails.member_reg_date)}
                    className="btn btn-outline-success btn-sm"
                  >
                    <i className="fa fa-certificate" /> Certificate
                  </button>:<div></div>}
              { memberPaymentActivityData && memberPaymentActivityData.length > 0 && memberPaymentActivityData[memberPaymentActivityData.length - 1].payment_status === 1 ?
                <button
                  onClick={handleInvoiceClick}
                  className="btn btn-outline-success btn-sm ml-2 " >
                  View Invoice
                </button>:<div></div>
              }
              </div>
              <div className="col-md-8">
                <div className="card">
                  <div className="body application_text_style">
                    <form id="basic-form" method=" " Validate>
                      <div className="row">
                        <div className="col-md-4">
                          <h4>State / City</h4>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <input
                              value={memberDetails.state_name}
                              disabled
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h4>Applicant Name</h4>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <input
                              value={`${memberDetails.salutation ? memberDetails.salutation : ""}${memberDetails.first_name ? memberDetails.first_name : ""}${memberDetails.middle_name ? " " + memberDetails.middle_name : ""}${memberDetails.last_name ? " " + memberDetails.last_name : ""}`}
                              disabled
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h4>Application Date</h4>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <input
                              value={convertDBDate(
                                memberDetails.member_reg_date
                              )}
                              disabled
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h4>Application ID</h4>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <input
                              value={memberDetails.application_no}
                              disabled
                              type="text"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <h4>Current Status</h4>
                        </div>
                        <div className="col-md-8">
                          <div className="traking_status_d_dlex">
                            <Link
                              to={`${ROUTE_BASE_URL}/user-member-application-preview/${slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <button
                                className="btn btn-outline-primary btn-block saveand_proced_button"
                                type="button"                              >
                                View Application
                              </button>
                            </Link>
                            <p className="m-0">
                              <span className="border_badge_track ml-0 mr-0 p-1 status-membership-number-allotted">
                                {`${memberDetails.status_name} ${memberDetails.membership_no ? "- " + memberDetails.membership_no : ""}`}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <div className="body application_text_style">
                    <h3>Application Timeline</h3>
                    <div>
                      <ul>
                        {memberActivityData &&
                          memberActivityData.length > 0 &&
                          memberActivityData.map((item) => (
                            <li key={item.id}>
                              <i className="fa fa-angle-right"></i>{" "}
                              {moment(item.created_on).format("DD MMM YYYY")} :{" "}
                              {item.status_name}
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
                {memberPaymentActivityData &&
                  memberPaymentActivityData.length > 0 && (
                    <div className="card">
                      <div className="body application_text_style">
                        <h3>Payment Timeline</h3>
                        <div>
                          <ul>
                            {memberPaymentActivityData.map((item) => (
                              <li key={item.id}>
                                <i className="fa fa-angle-right"></i>{" "}
                                {moment(item.created_on).format("DD MMM YYYY")}{" "}
                                : {item.payment_status_name}{" "}
                                <Link
                                  to="#"
                                  onClick={handlePaymentReceiptClick}
                                  className="invoice_link"
                                  style={{ cursor: "pointer" }}
                                >
                                  {item.payment_id}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
        {/* {loadingInvoice && <p>Loading invoice...</p>} */}
        {invoiceError && <p className="text-danger">{invoiceError}</p>}

        {showInvoice && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              backgroundColor: "#000000ad",
              padding: "20px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              overflow: "auto",
            }}
          >
            <button
              onClick={handleCloseInvoice}
              className="search_toggle btn btn-danger search_tracking_div">
              <i class="fa fa-times"></i>
            </button>
            {/* Invoice content (full screen width) */}
            <div
              style={{
                width: "100%", // Full screen width
                height: "100%", // Full screen height
                overflowY: "auto", // Ensure scrolling if content overflows
              }}
            >
              <Invoice invoiceData={invoiceData} />
            </div>
          </div>
        )}
        {showPaymentReceipt && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              backgroundColor: "#000000ad",
              padding: "20px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              overflow: "auto",
            }}
          >
            <button
              onClick={()=>handleClosePaymentReceipt()}
              className="search_toggle btn btn-danger search_tracking_div"
            >
              <i className="fa fa-times"></i>
            </button>
            <div
              style={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <PaymentReceipt invoiceData={invoiceData}/>
            </div>
          </div>
        )}
      {showMembershipCertificate && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backgroundColor: "#000000ad",
            padding: "20px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            overflow: "auto",
          }}
        >
          <button
            onClick={handleCloseMembershipCertificate}
            className="search_toggle btn btn-danger search_tracking_div"
          >
            <i className="fa fa-times"></i>
          </button>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <MembershipCertificate
              certificateDetails={certificateDetails}
              firstName={memberDetails.first_name}
              middleName={memberDetails.middle_name}
              lastName={memberDetails.last_name}
              applicationName={memberDetails.application_name}
              membershipNumber={memberDetails.membership_no}
              membershipDate={convertCertificateDate(memberDetails.member_reg_date)}
            />
          </div>
        </div>
      )}
        <Footer />
      </section>
    </div>
  );
};

export default UserMemberApplicationTracking;
